module.exports = __webpack_public_path__ + "img/4.0627bee0.png";